import { filesMockMode } from '@shared/lib/dev-mocks';

import { DEFAULT_ATTACHMENT_POLICY, setAttachmentPolicy } from '../data/attachment-policy';
import type { ChatService } from '../types';

import { createFilesMockChatService } from './files-mock-service';
import { createMockChatService } from './mock-service';

// ── Provider seam ────────────────────────────────────────────────────────────
//
// The whole module reaches the chat backend through `getChatService()`.
// It defaults to the local mock (deterministic for tests / no orchestrator
// dependency). The app swaps in the real orchestrator-backed service at
// startup via `initAiCio()`.

function initialChatService(): ChatService {
  if (import.meta.env.DEV) {
    const mode = filesMockMode();
    if (mode) return createFilesMockChatService({ saveMode: mode });
  }
  return createMockChatService();
}

let activeService: ChatService = initialChatService();
setAttachmentPolicy(activeService.attachmentPolicy ?? DEFAULT_ATTACHMENT_POLICY);

export function getChatService(): ChatService {
  return activeService;
}

export function setChatService(service: ChatService): void {
  activeService = service;
  setAttachmentPolicy(service.attachmentPolicy ?? DEFAULT_ATTACHMENT_POLICY);
}
